import { render, staticRenderFns } from "./u-file-input-filled-rounded.vue?vue&type=template&id=244f1412&scoped=true"
import script from "./u-file-input-filled-rounded.vue?vue&type=script&lang=js"
export * from "./u-file-input-filled-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f1412",
  null
  
)

export default component.exports